export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_el.f468c1f6c90edc73.json"